import { create } from "zustand"

import type { ConfettiStyle } from "@/hooks/use-confetti-cable"

interface ConfettiState {
  style: ConfettiStyle | null
  message: string | null
  trigger: (style: ConfettiStyle, message?: string) => void
  clear: () => void
}

export const useConfettiStore = create<ConfettiState>((set) => ({
  style: null,
  message: null,
  trigger: (style, message) => set({ style, message: message ?? null }),
  clear: () => set({ style: null, message: null }),
}))
